module.exports = __webpack_public_path__ + "static/media/novinky.f8e87096.jpg";